import CalloutBlock from './calloutBlock';

export default CalloutBlock;
